<template>
    <div id="app">
        <router-view/>
        <div class="footer-nav">
            <div class="nav-item" :class="{ active: $route.name === 'Home' }" @click="goPage('/')">
                <van-icon name="home-o" />
                <span>首页</span>
            </div>
            <div class="nav-item" :class="{ active: $route.name === 'video' || $route.name === 'videoPlay' }" @click="goPage('/video')">
                <van-icon name="play-circle-o" />
                <span>视频</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    methods: {
        goPage(path) {
            this.$router.push(path)
        }
    }
}
</script>

<style lang="less">
* {
    padding: 0;
    margin: 0;
}
body {
    font-family: "Microsoft Yahei", sans-serif;
    font-size: 1.5rem;
    color: #202020;
    background-color: #fff;
}
html,
body {
    height: 100%;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    // 禁止复制
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
}
a {
    text-decoration: none;
}
img {
    border: 0;
    vertical-align: middle;
}
em,
i {
    font-style: normal;
}
li {
    list-style: none;
}
button {
    cursor: pointer;
}
// 媒体查询
@media screen and (min-width: 320px)  {
    html {
        /* 当宽度大于等于320px时 html元素的字体大小为*/
        font-size:65%!important;
    }
}
@media screen and (min-width: 750px)  {
    html {
        /* 当宽度大于等于750px时 html元素的字体大小为*/
        font-size:100%!important;
    }
}
#app {
    width: 100%;
    max-width: 750px;
    margin: 0 auto;
    padding-bottom: 4.5rem;
}
.footer-nav {
    position: fixed;
    left: 50%;
    bottom: 0;
    transform: translateX(-50%);
    width: 100%;
    max-width: 750px;
    display: flex;
    background: #fff;
    box-shadow: 0 -2px 10px #eee;
    z-index: 999;
    .nav-item {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: .2rem;
        text-align: center;
        padding: .7rem 0;
        color: #666;
        font-size: 1rem;
        .van-icon {
            font-size: 1.35rem;
            line-height: 1;
        }
        &.active {
            color: #ff5a5e;
            font-weight: 700;
        }
    }
}
</style>